import { Link } from '@/i18n/navigation'
import { cn } from '@heroui/react'
import React from 'react'

export const NotificationMessage: React.FC<{
  title: string
  body?: string
  payload?: Record<string, unknown>
}> = ({ title, body, payload }) => {
  const isClickable = false

  const getHref = () => {
    if (!isClickable) return ''

    return ''
  }

  return (
    <Link
      href={getHref()}
      className={cn(isClickable ? 'cursor-pointer' : 'pointer-events-none')}
    >
      <h6 className='text-lg font-medium'>{title}</h6>
      {body ? <p>{body}</p> : null}
      {payload?.order_id ? (
        <p className='text-sm text-gray-500'>
          at order #{payload.order_id as string}
        </p>
      ) : null}
    </Link>
  )
}
